import VirginiaDataCenterMap from "@/components/site/VirginiaDataCenterMap";
import UtilityRateCharts from "@/components/site/UtilityRateCharts";
import PageMeta from "@/components/site/PageMeta";

export default function WhySolarNowPage() {
  return (
    <main className="pt-24 md:pt-32" data-testid="why-solar-now-page">
      <PageMeta
        title="Virginia Solar & Utility Costs | Jeremy with ION"
        description="Virginia's grid is under pressure from data-center demand and long-term infrastructure investment. See the latest approved utility-rate changes for Dominion Energy and Rappahannock Electric Cooperative."
      />
      <section className="pb-6 md:pb-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="eyebrow">Why Solar Now</div>
          <h1 className="mt-3 font-serif-display text-4xl sm:text-5xl lg:text-6xl font-semibold text-[#0F382C] max-w-4xl">
            The forecasts are already priced into your bill.
          </h1>
          <p className="mt-5 max-w-2xl text-lg text-slate-600">
            Virginia's grid is under pressure from data-center demand and long-term infrastructure investment. Locking a predictable rate today can help hedge against tomorrow's approved increases.
          </p>
        </div>
      </section>
      <VirginiaDataCenterMap />
      <UtilityRateCharts />
    </main>
  );
}
